/**
 * DemoModeBadge Component
 *
 * Visual indicator shown to users in demo mode.
 * Typically displayed in header or sidebar to make it clear they're using a demo account.
 */

'use client';

import Badge from '../ui/Badge';

interface DemoModeBadgeProps {
  className?: string;
}

export function DemoModeBadge({ className }: DemoModeBadgeProps) {
  return (
    <div className={className}>
      <Badge color="yellow">Demo Mode</Badge>
    </div>
  );
}

export default DemoModeBadge;
